import React from "react";
import {GlobalStyle} from "./src/styles/GlobalStyles";

export const wrapRootElement = ({element}) => (
    <>
        <GlobalStyle />
        {element}
    </>
);


export const wrapPageElement = ({element}) => (
    <>
        <GlobalStyle />
        {element}
    </>
);


